import { IconSearch } from '@tabler/icons-react'
import type { JSX } from 'react'
import { CommandMenuLink } from '#src/components/app/command-menu/CommandMenuLink.tsx'

export function SearchCommandLink({ search }: { search: string }): JSX.Element {
  return (
    <CommandMenuLink
      value={search}
      to={`/search?q=${search}`}
      className="flex gap-3"
    >
      <div className="p-0.5">
        <IconSearch className="size-4 shrink-0" />
      </div>
      <span className="whitespace-nowrap">Search entire system</span>
      <span className="line-clamp-1 text-foreground-secondary">{search}</span>
    </CommandMenuLink>
  )
}
